<template>
  <div class="contact-form"> <!-- Add the contact-form class here -->
    <img src="./assets/devimage.jpg" alt="Dev image" class="about-image">

    <h2>Contact Us</h2>
    <form @submit.prevent="submitForm">
      <div>
        <label for="name">Name:</label>
        <input type="text" id="name" v-model="formData.name" required>
      </div>
      <div>
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="formData.email" required>
      </div>
      <div>
        <label for="message">Message:</label>
        <textarea id="message" rows="4" v-model="formData.message" required></textarea>
      </div>
      <button type="submit">Submit</button>
    </form>
  </div>
</template>


<script setup>
import { ref } from 'vue';

// Form data
const formData = ref({
  name: '',
  email: '',
  message: ''
});

// Form submission
const submitForm = () => {
  // Here you can handle form submission, e.g., sending data to a server
  console.log('Form submitted:', formData.value);
  // Reset form fields after submission
  formData.value = {
    name: '',
    email: '',
    message: ''
  };
};
</script>

<style scoped>
.contact-form {
  max-width: 400px;
  margin: 0 auto;
}

/* Style for the form header */
.contact-form h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

/* Style for form inputs and labels */
.contact-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
}

.contact-form input[type="text"],
.contact-form input[type="email"],
.contact-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.contact-form textarea {
  resize: vertical; /* Allow vertical resizing of textarea */
}

.contact-form button {
  margin-bottom: 10px

}

/* Style for form submit button */
.contact-form button[type="submit"] {
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.contact-form button[type="submit"]:hover {
  background-color: #0056b3; /* Darker shade of primary color */
}
.conimage {
  width: 200px; /* Adjust image width to make it bigger */
  height: auto; /* Maintain aspect ratio */
  margin-right: 10px; /* Reduce margin to bring the image closer to the text */
}
</style>